module.exports = __webpack_public_path__ + "static/media/jsfiddle.b0fc9a79.svg";